const React = require('react')
const PropTypes = require('prop-types')
const AnonymousLedge = require('./anonymous_ledge/anonymous_ledge')
const log = require('log').create('anonymous prompt') // eslint-disable-line

function AnonymousPrompt({ is_logged_in }) {

    if (is_logged_in) return null

    // for now, only one anonymous prompt in use
    // could change this to use RenderOne later
    return (
        <AnonymousLedge />
    )
}

AnonymousPrompt.propTypes = {
    is_logged_in: PropTypes.bool,
}

module.exports = AnonymousPrompt
